<template>
  <v-card
    outlined
    elevation="2"
    height="calc(100vh - 100px)"
    class="overflow-y-auto"
  >
    <v-card-title class="sticky-title">
      <!-- tablero -->
      <v-row class="justify-space-between">
        <v-col cols="12" sm="3">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Competencia"
            :items="competencias"
            item-value="id"
            item-text="competencia"
            v-model="competencia"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="3">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Habilidad"
            :items="habilidades"
            item-value="id"
            item-text="categoria"
            v-model="habilidad"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="3">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Regional"
            :items="regionales"
            item-value="id"
            item-text="regional"
            v-model="regional"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="3">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Centro de Formación*"
            :items="centrosFormacion"
            item-value="id"
            item-text="centro_formacion"
            v-model="centroFormacion"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>
      </v-row>

      <!-- contadores  -->
      <v-row>
        <v-col cols="12" sm="3">
          <CounterCard
            color="#FF5722"
            :value="participantesTotales"
            icon="mdi-folder-multiple"
            label="Participantes"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <CounterCard
            color="#9C27B0"
            :value="ganadoresTotales"
            icon="mdi-text-box-plus"
            label="Ganadores"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <CounterCard
            color="#3F51B5"
            :value="expertosTotales"
            icon="mdi-account-group"
            label="Expertos"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <CounterCard
            color="#4CAF50"
            :value="acompañastesTotales"
            icon="mdi-account-multiple"
            label="Acompañantes"
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <!-- grafico participantes x habilidad -->
      <v-row>
        <v-col cols="12">
          <v-card outlined elevation="2">
            <v-card-text>
              <BarChart
                :data="participantesGanadoresHabilidadesData"
                :options="participantesGanadoresHabilidadesOptions"
              >
              </BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- grafico participantes x habilidad -->
      <v-row>
        <v-col cols="12" sm="6">
          <v-card outlined elevation="2">
            <v-card-text>
              <PieChart
                :data="participantesHabilidadData"
                :options="participantesHabilidadesOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card outlined elevation="2">
            <v-card-text>
              <PieChart
                :data="ganadoresHabilidadData"
                :options="ganadoresHabilidadesOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- grafico participantes ganadores x regional -->
      <v-row>
        <v-col cols="12">
          <v-card outlined elevation="2">
            <v-card-text>
              <BarChart
                :data="participantesGanadoresRegionalData"
                :options="participantesGanadoresRegionalOptions"
              >
              </BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card outlined elevation="2">
            <v-card-text>
              <PieChart
                :data="expertosTipoData"
                :options="expertosTipoOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card outlined elevation="2">
            <v-card-text>
              <PieChart
                :data="acompañantesTipoData"
                :options="acompañantesTipoOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import CounterCard from "../../components/admin/CounterCard.vue";
import BarChart from "../../components/admin/BarChart.vue";
import PieChart from "../../components/admin/PieChart.vue";

export default {
  data: () => ({
    competencia: null,
    habilidad: null,
    regional: null,
    centroFormacion: null,
  }),

  components: {
    CounterCard,
    BarChart,
    PieChart,
  },

  mounted() {
    this.$store.dispatch("gestionarCompetenciasWorldSkills");
    this.$store.dispatch("gestionarHabilidades");
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch("participantesWorldskillsHabilidadTablero", null);
    this.$store.dispatch("ganadoresHabilidadWorldSkillsTablero", null);
    this.$store.dispatch("expertoTipoWorldSkillsTablero", null);
    this.$store.dispatch("acompañantesTipoWorldSkillsTablero", null);
    this.$store.dispatch("participantesRegionalWorldskillsTablero", null);
    this.$store.dispatch("ganadoresRegionalWorldSkillsTablero", null);
  },

  computed: {
    competencias() {
      return this.$store.getters.obtenerCompetenciasWorldSkills.filter(
        (competencia) =>
          competencia.tipo_competencia_id == 2 ||
          competencia.tipo_competencia_id == 3 ||
          competencia.tipo_competencia_id == 4,
      );
    },
    habilidades() {
      return this.$store.getters.obtenerHabilidades;
    },
    regionales() {
      return this.$store.getters.obtenerRegionales;
    },
    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacionTablero;
    },
    participantesHabilidades() {
      return this.$store.getters.obtenerParticipantesHabilidadWorldSkills;
    },
    ganadoresHabilidades() {
      return this.$store.getters.obtenerGanadoresHabilidadWorldSkills;
    },
    participantesRegional() {
      return this.$store.getters.obtenerParticipantesRegionalWorldSkills;
    },
    ganadoresRegional() {
      return this.$store.getters.obtenerGanadoresRegionalWorldSkills;
    },
    expertosTipo() {
      return this.$store.getters.obtenerExpertosTipoWorldSkills;
    },
    acompañantesTipo() {
      return this.$store.getters.obtenerAcompanantesTipoWorldSkills;
    },

    participantesTotales() {
      return this.participantesHabilidades.reduce(
        (sum, p) => sum + p.participantes,
        0,
      );
    },
    ganadoresTotales() {
      return this.ganadoresHabilidades.reduce((sum, g) => sum + g.ganadores, 0);
    },
    expertosTotales() {
      return this.expertosTipo.reduce((sum, e) => sum + e.expertos, 0);
    },
    acompañastesTotales() {
      return this.acompañantesTipo.reduce((sum, a) => sum + a.acompanantes, 0);
    },

    // options y data graficas
    // Barcharts

    participantesGanadoresHabilidadesData() {
      const ganadores = this.ganadoresHabilidades.map((g) => g.ganadores);
      const participantes = this.participantesHabilidades.map(
        (p) => p.participantes,
      );
      const habilidades = this.participantesHabilidades.map((c) => c.categoria);

      return {
        labels: habilidades,
        datasets: [
          {
            label: "Participantes",
            data: participantes,
            backgroundColor: "#C5CAE9",
            borderColor: "#3F51B5",
            borderWidth: 2,
          },
          {
            label: "Ganadores",
            data: ganadores,
            backgroundColor: "#E1BEE7",
            borderColor: "#9C27B0",
            borderWidth: 2,
          },
         
        ],
      };
    },
    participantesGanadoresHabilidadesOptions() {
      const chartOptions = {
        indexAxis: "y",
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            ticks: {
              autoSkip: false,
              callback: function (val) {
                const texto = this.getLabelForValue(val);

                if (texto.length > 80) {
                  return texto.slice(0, 80) + "...";
                } else {
                  return texto;
                }
              },
            },
            grid: {
              display: false,
            },
          },
        },
      };

      return chartOptions;
    },
    participantesGanadoresRegionalData() {
      const ganadores = this.ganadoresRegional.map((g) => g.ganadores);
      const participantes = this.participantesRegional.map(
        (p) => p.participantes,
      );
      const regionales = this.participantesRegional.map((c) => c.regional);

      return {
        labels: regionales,
        datasets: [
          {
            label: "Participantes",
            data: participantes,
            backgroundColor: "#C5CAE9",
            borderColor: "#3F51B5",
            borderWidth: 2,
          },
          {
            label: "Ganadores",
            data: ganadores,
            backgroundColor: "#E1BEE7",
            borderColor: "#9C27B0",
            borderWidth: 2,
          },
          
        ],
      };
    },
    participantesGanadoresRegionalOptions() {
      const chartOptions = {
        indexAxis: "y",
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            ticks: {
              autoSkip: false,
              callback: function (val) {
                const texto = this.getLabelForValue(val);

                if (texto.length > 80) {
                  return texto.slice(0, 80) + "...";
                } else {
                  return texto;
                }
              },
            },
            grid: {
              display: false,
            },
          },
        },
      };

      return chartOptions;
    },

    // options y data graficas
    // Piecharts

    participantesHabilidadData() {
      const habilidades = this.participantesHabilidades.map((p) => p.categoria);
      const participantes = this.participantesHabilidades.map(
        (p) => p.participantes,
      );
      return {
        labels: habilidades,
        datasets: [
          {
            data: this.generarPorcentaje(participantes),
            backgroundColor: this.generarColorRGB(habilidades.length),
          },
        ],
      };
    },
    participantesHabilidadesOptions() {
      return {
        hoverOffset: 8,
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Participantes por habilidad",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        },
      };
    },
    ganadoresHabilidadData() {
      const habilidades = this.participantesHabilidades.map((p) => p.categoria);
      const ganadores = this.ganadoresHabilidades.map((p) => p.ganadores);
      return {
        labels: habilidades,
        datasets: [
          {
            data: this.generarPorcentaje(ganadores),
            backgroundColor: this.generarColorRGB(habilidades.length),
          },
        ],
      };
    },
    ganadoresHabilidadesOptions() {
      return {
        hoverOffset: 8,
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Ganadores por habilidad",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        },
      };
    },
    expertosTipoData() {
      const experto = this.expertosTipo.map((e) => e.expertos);
      const tipo = this.expertosTipo.map((p) => p.tipos_experto);
      return {
        labels: tipo,
        datasets: [
          {
            data: this.generarPorcentaje(experto),
            backgroundColor: this.generarColorRGB(tipo.length),
          },
        ],
      };
    },
    expertosTipoOptions() {
      return {
        hoverOffset: 8,
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Experto por tipo",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        },
      };
    },
    acompañantesTipoData() {
      const acompañante = this.acompañantesTipo.map((e) => e.acompanantes);
      const tipo = this.acompañantesTipo.map((p) => p.tipos_acompanante);
      return {
        labels: tipo,
        datasets: [
          {
            data: this.generarPorcentaje(acompañante),
            backgroundColor: this.generarColorRGB(tipo.length),
          },
        ],
      };
    },
    acompañantesTipoOptions() {
      return {
        hoverOffset: 8,
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Acompañante por tipo",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        },
      };
    },
  },

  methods: {
    cargarDatos() {
      const filtros = {
        competencia: this.competencia,
        categoria: this.habilidad,
        regional: this.regional,
        centro_formacion: this.centroFormacion,
      };
      this.$store.dispatch("participantesWorldskillsHabilidadTablero", filtros);
      this.$store.dispatch("ganadoresHabilidadWorldSkillsTablero", filtros);
      this.$store.dispatch("expertoTipoWorldSkillsTablero", filtros);
      this.$store.dispatch("acompañantesTipoWorldSkillsTablero", filtros);
      this.$store.dispatch("participantesRegionalWorldskillsTablero", filtros);
      this.$store.dispatch("ganadoresRegionalWorldSkillsTablero", filtros);
    },
    generarPorcentaje(valores) {
      const total = valores.reduce(
        (suma, currentValue) => suma + currentValue,
        0,
      );
      const porcentaje = valores.map((valor) =>
        ((valor / total) * 100).toFixed(1),
      );
      return porcentaje;
    },
    generarColorRGB(cantidad) {
      const coloresAleatorios = [];

      for (let i = 0; i < cantidad; i++) {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        coloresAleatorios.push(`rgb(${r}, ${g}, ${b})`);
      }

      return coloresAleatorios;
    },
  },
};
</script>
<style scoped>
.sticky-title {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}
</style>
